import { useState } from "react"
import type { MouseEvent } from "react"

export interface PointerMenuState {
  open: boolean
  setOpen: (open: boolean) => void
  point: { x: number; y: number } | null
  onContextMenu: (e: MouseEvent) => void
}

/**
 * Right-click (or a two-finger trackpad click, which the browser reports as
 * the same `contextmenu` event) on an item opens its existing three-dot menu
 * at the pointer, instead of the browser's own menu.
 *
 * Backs off (no `preventDefault`, so the browser menu still opens) inside
 * anything the pointer already has a native meaning for: a field being typed
 * into, a link someone might want "open in new tab" on, or a text selection
 * they just made, which a right-click is commonly used to copy.
 */
export function usePointerMenu(disabled?: boolean): PointerMenuState {
  const [open, setOpen] = useState(false)
  const [point, setPoint] = useState<{ x: number; y: number } | null>(null)

  const onContextMenu = (e: MouseEvent) => {
    if (disabled) return
    const target = e.target as HTMLElement
    if (target.closest('input, textarea, select, [contenteditable="true"], a[href]')) return
    if (window.getSelection()?.toString()) return
    e.preventDefault()
    setPoint({ x: e.clientX, y: e.clientY })
    setOpen(true)
  }

  return { open, setOpen, point, onContextMenu }
}
